import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'
import App from './App'
import './index.css'

const domain = import.meta.env.VITE_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
const audience = import.meta.env.VITE_AUTH0_AUDIENCE

console.log('Auth0 Config:', { domain, clientId, audience })

const onRedirectCallback = (appState?: { returnTo?: string }) => {
  console.log('Auth0 redirect callback:', appState)
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || window.location.pathname
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: window.location.origin + '/callback',
          audience: audience,
          scope: 'openid profile email'
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        onRedirectCallback={onRedirectCallback}
      >
        <App />
      </Auth0Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
